import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import ProductAccordion from "../components/ProductAccordion.tsx";
import ProductDetails from "../components/ProductDetails.tsx";
import { Product } from "../types/product.tsx";
import { productsArr } from "../data/products.ts";

const Products = () => {
	const isMobile = useMediaQuery({ maxWidth:767 });
	const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

	const handleSelect = (product: Product) => {
		if (selectedProduct?.id === product.id) { setSelectedProduct(null);	}
		else { setSelectedProduct(product); }
	};

	const handleClose = () => {
		setSelectedProduct(null);
	};

	return (
		<div className="container" data-mobile={`${isMobile}`}>
			<div className="content-wrapper">
				{productsArr.map((p) => (
					<ProductAccordion
						key={p.id}
						product={p}
						onSelect={handleSelect}
					/>
				))}
			</div>

			{selectedProduct && (
				<ProductDetails product={selectedProduct} onClose={handleClose} />
			)}
		</div>
	);
};

export default Products;